import React from 'react';
import {Button, Typography} from '@mui/material';
import {usePageView, useTranslate} from 'hooks';
import {AlertBanner} from '@resurs-internal/mui';
import {ErrorView} from './ErrorView';
import {isEdge} from '../../services/browser';
import {Link} from '@tanstack/react-router';

type ErrorPageProps = {
  error?: Error;
  componentStack?: string;
  eventId?: string;
};

export const ErrorPage = (props: ErrorPageProps) => {
  const translate = useTranslate();
  usePageView('error');

  return (
    <ErrorView title={translate('common.error')}>
      {isEdge && (
        <AlertBanner
          severity={'warning'}
          title={translate('common.error.edge.title')}
          subtitle={translate('common.error.edge.subtitle')}
        />
      )}
      <Link to={'/'}>
        <Button>{translate('common.return-home')}</Button>
      </Link>

      {props.eventId && <Typography>ID: {props.eventId}</Typography>}
      {props.error && <Typography>{props.error.toString()}</Typography>}
      {props.componentStack && (
        <details>
          <summary>Stack</summary>
          {props.componentStack}
        </details>
      )}
    </ErrorView>
  );
};
